import { Component } from '@angular/core';
import { NavParams, ModalController } from '@ionic/angular';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.page.html',
  styleUrls: ['./welcome.page.scss']
})
export class WelcomePage {

  language: string;

  en_button = 'Ok!';
  en_title = 'Welcome to Learn! Japanese';
  en_welcome = 'This app will help you to learn, write and understand the basics of the japanese language.';
  en_first = 'The japanese language is divided into two syllabaries:';
  en_second = `This is the one that the japanese people use on a daily basis. This set contains
    the characters which the kanjis are composed of.`;
  en_third = 'This set serves only to bring foreign expressions or words into the japanese alphabet.';
  en_fourth = 'Each of the characters of these two syllabaries are pronounced equally, there is no difference. Do not worry about that!';
  en_fifth = 'The only differ on how they are written!';
  en_sixth = 'So, lets get started!';
  en_disclaimer = `* Please, remember that this web is powered by artificial intelligence and the
    results shown may not be the exact ones. All drawings will be saved on the cloud in order to
    create a new dataset of characters. *`;

  sp_button = '¡Vamos!';
  sp_title = 'Bienvenido a ¡Aprende! Japonés';
  sp_welcome = 'Esta aplicación te ayudará a aprender, escribir y entender las bases del idioma japonés.';
  sp_first = 'El japonés se divide en dos silabarios:';
  sp_second = `Este silabario es el que los japoneses usan a diario. El conjunto contiene los
    caracteres de los cuales se componen los kanji.`;
  sp_third = 'Este conjunto sirve únicamente para trasladar expresiones o palabras anglosajonas o extranjeras al japonés.';
  sp_fourth = `Tanto hiragana como katakana se componen de 46 caracteres. Cada uno de ellos se
    pronuncian igual que en el otro conjunto, no hay diferencia en la pronunciación. ¡No hay de
    qué preocuparse!`;
  sp_fifth = '¡Solo se diferencian en cómo se escriben!';
  sp_sixth = 'Así que, ¡empecemos!';
  sp_disclaimer = `* Por favor, recuerda que esta web se sustenta en inteligencia artificial
    y los resultados mostrados pueden no ser los exactos. Todos los dibujos que se realicen
    serán almacenados en la nube para la creación de un nuevo conjunto de datos de caracteres. *`;


  constructor(private _viewCtrl: ModalController, private _params: NavParams) {
    this.language = this._params.get('language');
  }

  goBack() {
    this._viewCtrl.dismiss();
  }

}
